import { combineReducers } from 'redux';
import userFavorites from './favorites/GetUserFavorites';
import addFavorites from './favorites/AddFavorites';
import deleteFavorites from './favorites/DeleteFavorites';
import getDashboardList from './dashboard/GetDashboardList';
import getDashboardURLs from './dashboard/GetDashboardURL';
import getCurrentDashboard from './dashboard/GetCurrentDashboard';
import sageMakerUrl from './dashboard/GetSageMakerUrl';
import userOnBoarding from './user/UserOnBoarding';
import userDetails from './user/UserDetails';
import getUserGuide from './userguide/UserGuide';
import getWhatsNew from './whatsnew/WhatsNew';
import requestReportSubmit from './reports/RequestReport';
import getFaqs from './faqs/Faqs';
import getNotifications from './notification/Notification';
import saveToken from './token/SaveToken';

/*
 * ALL your reducers must go into allReducers so they can be combined back together to update the 1 store.
 * Don't forget to import them before adding them to JSON.
 */
const appReducer = combineReducers({
  userFavorites,
  addFavorites,
  deleteFavorites,
  getDashboardList,
  getDashboardURLs,
  getCurrentDashboard,
  sageMakerUrl,
  userOnBoarding,
  userDetails,
  getUserGuide,
  getWhatsNew,
  requestReportSubmit,
  getFaqs,
  getNotifications,
  saveToken,
});
const initialState = appReducer({}, {});
const rootReducer = (state, action) => {
  if (action.type === 'EMPTY_STORE') {
    // eslint-disable-next-line no-param-reassign
    state = initialState;
  }

  return appReducer(state, action);
};

export default rootReducer;
